import path from 'path';
import { S3Url } from 's3u';
import { isUrlPointsToFile } from '../../../../store/utils';
import { getServiceTitleByUrl } from '../../store/utils';

export default function urlToNavigationItems(
  url: string,
): Array<{ name: string; url: string }> {
  const s3Url = new S3Url(url);
  if (!s3Url.isValid) {
    return [];
  }

  const isS3Provider = s3Url.provider && s3Url.provider.id !== 'generic';

  const items = [
    {
      name: getServiceTitleByUrl(url) || '',
      url: isS3Provider
        ? s3Url.clone({ bucket: '', key: '' }).href
        : getBaseUrl(url),
    },
    (isS3Provider &&
      s3Url.bucket && {
        name: s3Url.bucket,
        url: endSlash(s3Url.clone({ key: '' }).href),
      }) as { name: string; url: string },
  ];

  const hierarchy = (s3Url.key || '').split('/').filter(Boolean);
  let keyPath = '';

  for (const fileName of hierarchy) {
    keyPath = path.join(keyPath, fileName);
    const newUrl = s3Url.clone({ key: keyPath }).href;

    if (!isUrlPointsToFile(newUrl)) {
      items.push({ name: decodeURIComponent(fileName), url: endSlash(newUrl) });
    }
  }

  return items.filter(Boolean);
}

function endSlash(url: string): string {
  return url.endsWith('/') ? url : `${url}/`;
}

function getBaseUrl(url: string): string {
  try {
    return new URL(url).origin;
  } catch {
    return '';
  }
}
